import React, { RefObject, useEffect, useRef, JSX } from 'react';
import { ApiGeoUnitWithDayConstraints } from '@ibe/api';

let timeOut: ReturnType<typeof setTimeout>;

const NestedGeoUnitsSelectOption = (props: {
  option: ApiGeoUnitWithDayConstraints;
  selectedOption?: ApiGeoUnitWithDayConstraints | null;
  openParents: Record<string, number>;
  onClick: (option: ApiGeoUnitWithDayConstraints) => void;
  parentTypeCode: string;
  scrollContainerRef: RefObject<HTMLDivElement | null>;
}): JSX.Element => {
  const {
    option,
    selectedOption,
    openParents,
    onClick,
    parentTypeCode,
    scrollContainerRef
  } = props;
  const scrollItemRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   if (
  //     option.typeCode === parentTypeCode &&
  //     option.code === selectedOption?.code &&
  //     !!scrollContainerRef.current &&
  //     !!scrollItemRef.current
  //   ) {
  //     scrollContainerRef.current.scrollTo({
  //       top: scrollItemRef.current.offsetTop,
  //       behavior: 'smooth'
  //     });
  //   }
  // }, [option, parentTypeCode, openParents, scrollContainerRef, scrollItemRef]);

  useEffect(() => {
    return (): void => {
      if (!!timeOut) {
        clearTimeout(timeOut);
      }
    };
  }, []);

  const handleClick = (): void => {
    onClick(option);
    if (option.typeCode === parentTypeCode && !openParents[option.code]) {
      timeOut = setTimeout((): void => {
        if (!!scrollContainerRef.current && !!scrollItemRef.current) {
          scrollContainerRef.current.scrollTo({
            top: scrollItemRef.current.offsetTop,
            behavior: 'smooth'
          });
        }
      }, 350);
    }
  };

  return (
    <div
      ref={scrollItemRef}
      className={`nested-geounits-select__option${
        option.typeCode === parentTypeCode ? ' nested-geounits-select__option--parent' : ''
      }${option.code === selectedOption?.code ? ' nested-geounits-select__option--selected' : ''}`}
      onClick={handleClick}
    >
      {option.name}
    </div>
  );
};

export default NestedGeoUnitsSelectOption;
